var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mt-2" }, [
    _c("ul", { staticClass: "nav my-2" }, [
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            class: [_vm.currentTab === 0 ? "btn-primary" : ""],
            on: {
              click: function($event) {
                _vm.currentTab = 0
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("productQualityTests.main.name")) + "\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            class: [_vm.currentTab === 2 ? "btn-primary" : ""],
            on: {
              click: function($event) {
                _vm.currentTab = 2
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("productQualityTests.main.quitted")) +
                "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            class: [_vm.currentTab === 4 ? "btn-primary" : ""],
            on: {
              click: function($event) {
                _vm.currentTab = 4
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("productQualityTests.main.group")) +
                "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            class: [_vm.currentTab === 7 ? "btn-primary" : ""],
            on: {
              click: function($event) {
                _vm.currentTab = 7
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "productQualityTests.main.measurementSpecificationTemplates"
                  )
                ) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentTab === 0,
            expression: "currentTab === 0"
          }
        ]
      },
      [_c("PqtList", { attrs: { filter: _vm.unarchivedFunction } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentTab === 2,
            expression: "currentTab === 2"
          }
        ]
      },
      [
        _c("PqtList", {
          attrs: {
            filter: _vm.archivedFunction,
            editable: false,
            showArchiveFields: true
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentTab === 4,
            expression: "currentTab === 4"
          }
        ]
      },
      [
        _c("Abstract", {
          attrs: {
            type: "group",
            data: _vm.state.groupsStore.groupTypes,
            api: _vm.groupAPI,
            objectInstanciator: _vm.GroupTypeInstanciator
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentTab === 7,
            expression: "currentTab === 7"
          }
        ]
      },
      [_c("MeasurementSpecificationTemplates")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }